export const messages = {
  en: {
    cache: {
      flush:'flush',

      list: {
        title: 'cache List'
      },
      dialog: {
        addTitle: 'Add Cache',
        editTitle: 'Edit Cache',
        delTitle: 'Delete Cache',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      table: {
        cacheCode: 'cacheCode',
        serviceCode: 'serviceCode',
        name: 'name',
        seq: 'seq',
        group: 'group',
        createTime: 'createTime',
        url: 'url',
      },
      add: {
        success: 'Add Cache success'
      },
      edit: {
        success: 'Edit Cache success'
      },
      delete: {
        success: 'Delete Cache success',
        confirm: 'Are you sure to delete this cache?'
      },
      fetchError: 'Failed to fetch cache list'
    }
  },
  zh: {
    cache: {
      flush:'刷新',
      list: {
        title: '刷新缓存'
      },
      dialog: {
        addTitle: '添加刷新缓存',
        editTitle: '编辑刷新缓存',
        delTitle: '删除刷新缓存',
        cancel: '取消',
        confirm: '确定'
      },
      table: {
        cacheCode: '缓存编码',
        serviceCode: '服务编码',
        name: '名称',
        seq: '顺序',
        group: '组',
        createTime: '创建时间',
        url: '地址',
      },
      validate: {
        cacheCode: '请输入缓存编码 开始于1001',
        serviceCode: '请输入调用服务编码 对应 c_service',
        name: '请输入前台显示名称',
        seq: '请输入列顺序',
        group: '请输入组，缓存属于哪个组',
        createTime: '请输入创建时间',
        url: '请输入地址',
      },
      add: {
        success: '添加刷新缓存成功'
      },
      edit: {
        success: '编辑刷新缓存成功'
      },
      delete: {
        success: '删除刷新缓存成功',
        confirm: '确认删除该刷新缓存吗？'
      },
      fetchError: '获取刷新缓存列表失败'
    }
  },
  'zh-TW': {
    cache: {
      flush:'刷新',
      list: {
        title: '刷新緩存'
      },
      dialog: {
        addTitle: '添加刷新緩存',
        editTitle: '編輯刷新緩存',
        delTitle: '刪除刷新緩存',
        cancel: '取消',
        confirm: '確定'
      },
      table: {
        cacheCode: '緩存編碼',
        serviceCode: '服務編碼',
        name: '名稱',
        seq: '順序',
        group: '組',
        createTime: '創建時間',
        url: '地址',
      },
      validate: {
        cacheCode: '請輸入緩存編碼 開始於1001',
        serviceCode: '請輸入調用服務編碼 對應 c_service',
        name: '請輸入前台顯示名稱',
        seq: '請輸入列順序',
        group: '請輸入組，緩存屬於哪個組',
        createTime: '請輸入創建時間',
        url: '請輸入地址',
      },
      add: {
        success: '添加刷新緩存成功'
      },
      edit: {
        success: '編輯刷新緩存成功'
      },
      delete: {
        success: '刪除刷新緩存成功',
        confirm: '確認刪除該刷新緩存嗎？'
      },
      fetchError: '獲取刷新緩存列表失敗'
    }
  }
}